
<div *ngIf="showLayout">
    <app-car-insurance-navbar></app-car-insurance-navbar>
    <app-car-insurance-banner></app-car-insurance-banner>
    <app-car-insurance-whytochoose></app-car-insurance-whytochoose>
    <app-car-insurance-whyyouneed></app-car-insurance-whyyouneed>
    <app-car-insurance-product></app-car-insurance-product>
    <app-car-insurance-footer></app-car-insurance-footer>
</div>
    <router-outlet></router-outlet>

